import { PDF_EXPORT_QUERY_PARAM_EXPORT_MODE } from 'common/constants/pdfExport';

export const RELATED_ENTITY_OWNER_VALUE = 'related_entity';
export const FUND_OWNER_VALUE = 'fund';
export const NAME_SHEET_FUND_KEY = '_f';
export const NAME_SHEET_RELATED_ENTITY_KEY = '_re';

// Waterfall query params
export const WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE = 'exit-equity-value';
export const WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE = 'exit-enterprise-value';
export const WATERFALL_QUERY_PARAM_EXIT_DATE = 'exit-date';
export const WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION = 'cap-table-version';
export const WATERFALL_QUERY_PARAM_DATE = 'date';
export const WATERFALL_QUERY_PARAM_EXPORT_MODE = PDF_EXPORT_QUERY_PARAM_EXPORT_MODE;
export const WATERFALL_QUERY_PARAM_CURRENT_PAGE = 'currentPage';
export const WATERFALL_QUERY_PARAM_TOTAL_PAGES = 'totalPages';
export const WATERFALL_QUERY_PARAMS = [
  WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_DATE,
  WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION,
  WATERFALL_QUERY_PARAM_EXPORT_MODE,
  WATERFALL_QUERY_PARAM_CURRENT_PAGE,
  WATERFALL_QUERY_PARAM_TOTAL_PAGES,
];

// Allowed parameters for waterfall page
export const WATERFALL_ALLOWED_PARAMS = [
  WATERFALL_QUERY_PARAM_CAP_TABLE_VERSION,
  WATERFALL_QUERY_PARAM_EXIT_EQUITY_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_ENTERPRISE_VALUE,
  WATERFALL_QUERY_PARAM_EXIT_DATE,
  WATERFALL_QUERY_PARAM_DATE,
  WATERFALL_QUERY_PARAM_EXPORT_MODE,
  WATERFALL_QUERY_PARAM_CURRENT_PAGE,
  WATERFALL_QUERY_PARAM_TOTAL_PAGES,
]
